import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const Route = createFileRoute("/")({
  component: Login,
});

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate({ to: "/app/home" });
    }, 500);
  };

  return (
    <div className="app-viewport flex flex-col bg-bg px-6 pb-10 pt-14">
      <div className="mb-10">
        <div
          className="mb-4 grid h-12 w-12 place-items-center rounded-2xl"
          style={{ background: "var(--accent-soft)" }}
        >
          <Sparkles size={22} style={{ color: "var(--accent)" }} />
        </div>
        <h1 className="text-[var(--fs-2xl)] font-semibold tracking-tight">
          Wish Points
        </h1>
        <p className="mt-1 text-[var(--fs-sm)]" style={{ color: "var(--muted)" }}>
          心愿点数 · 家里的温柔记录本
        </p>
      </div>

      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="email">邮箱</Label>
          <Input
            id="email"
            type="email"
            autoComplete="email"
            inputMode="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="pwd">密码</Label>
          <Input
            id="pwd"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <Button type="submit" className="h-12 w-full text-base" disabled={loading}>
          {loading ? "登录中…" : "登录"}
        </Button>
        <div className="flex items-center justify-between text-[var(--fs-sm)]">
          <Link to="/forgot" style={{ color: "var(--accent)" }}>
            忘记密码?
          </Link>
        </div>
      </form>

      <p
        className="mt-auto pt-10 text-center text-[var(--fs-xs)]"
        style={{ color: "var(--muted)" }}
      >
        还没有账号?请联系家庭管理员开通。
      </p>
    </div>
  );
}
